import { generatePath } from "react-router-dom";
import { CMC_MIGRATION_SUBROUTE, getProjectSubRouteTemplate, PROJECT_SUBROUTE } from "../app/AppRoutes";

export const generateMigrationSubPathRoute = (projectId: string, migrationSubRoute: CMC_MIGRATION_SUBROUTE) => {
    const p = generatePath(getProjectSubRouteTemplate(PROJECT_SUBROUTE.CMC_MIGRATIONS) + `/${migrationSubRoute}`, { projectId });
    return p;
};

export const generateMigrationSessionDetailsPath = (projectId: string, sessionId: string) => {
    const p = generatePath(`${generateMigrationSubPathRoute(projectId, CMC_MIGRATION_SUBROUTE.SESSIONS)}/${sessionId}`, { projectId });
    return p;
};

export const generateMigrationSessionSubPathRoute = (projectId: string, sessionId: string, migrationSessionSubRoute: CMC_MIGRATION_SUBROUTE | "") => {
    const p = generatePath(`${generateMigrationSubPathRoute(projectId, CMC_MIGRATION_SUBROUTE.SESSIONS)}/${sessionId}/${migrationSessionSubRoute}`, {
        projectId,
    });
    return p;
};
